import React from 'react'
// Local
import { BASE_URL } from '../../config'
import { API_URL } from '../../constant'

type Props = {
  encounterId: string | undefined
  isCdi: boolean
}

// @param encounterId If defined, render iframe with PDF report for specified encounter
function Pdf(
  props: Props
): JSX.Element {
  const {
    encounterId = '',
    isCdi
  } = props
  const reportUrl = isCdi === true
    ? API_URL.PDF_ENCOUNTER_FOR_CDI_REPORT(encounterId)
    : API_URL.PDF_ENCOUNTER_REPORT(encounterId)

  return (
    <iframe
      title="Encounter PDF"
      className="pdf-iframe"
      src={ BASE_URL + reportUrl }
    />
  )
}

export default Pdf
